<template>
  <div>
    <v-menu v-model="menu" offset-y left>
      <template v-slot:activator="{ on }">
        <v-btn icon small ripple v-on="on" aria-label="Flere valg">
          <v-icon style="font-size: 20px;" :color="color"
            >mdi-dots-vertical</v-icon
          >
        </v-btn>
      </template>

      <v-card max-width="250">
        <v-list>
          <v-list-tile avatar v-show="false">
            <v-list-tile-content>
              <v-list-tile-title>{{ item.appTitle }}</v-list-tile-title>
            </v-list-tile-content>

            <v-list-tile-action v-if="item.type !== 'graphicsLayer'">
              <layer-favourite-toggler :layerId="item.id" />
            </v-list-tile-action>
          </v-list-tile>
        </v-list>

        <v-list>
          <v-divider></v-divider>
          <v-list-tile class="pl-3" v-show="false">
            <v-list-tile-title>Vis tema i kart</v-list-tile-title>
            <v-list-tile-action>
              <v-switch
                @change="toggleTheme" label="Vis/skjul tema"
                :input-value="item.visible"
                color="blue"
              ></v-switch>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider></v-divider>
          <v-list-tile v-show="false" style="height: 100px;">
            <v-list-tile-action>
              <v-slider
                class="pt-5 mt-5 pl-2 pr-4"
                @change="setOpacity(item.id, opacity)"
                v-model="opacity"
                color="blue"
                aria-label="Velg synlighet for temaet"
                persistent-hint
                thumb-label="always"
                step="10"
                hint="Velg synlighet for temaet i prosent"
                max="100"
                ticks
              >
                <template v-slot:thumb-label="props">
                  <span>
                    {{ props.value + "%" }}
                  </span>
                </template>
              </v-slider>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider></v-divider>
        </v-list>

        <v-list class="pt-0">
          <v-list-tile
            :disabled="this.selectedTheme === item.id || !profileHasDescription"
            @click="openInfo($event, item)"
          >
            <v-list-tile-title>Vis beskrivelse</v-list-tile-title>
          </v-list-tile>

          <v-list-tile
            @click="duplicateGraphicsLayerAndAddToMap(item)"
            v-if="item.type == 'graphicsLayer'"
          >
            <v-list-tile-title>Dupliser tegnelag</v-list-tile-title>
          </v-list-tile>

          <v-list-tile
            @click="downloadAsShape(item)"
            v-if="item.type == 'graphicsLayer'"
          >
            <v-list-tile-title>Eksporter til shapefil</v-list-tile-title>
          </v-list-tile>
          <v-list-tile
            @click="pasteGeometry"
            v-if="item.type == 'graphicsLayer'"
            :disabled="copiedGeometry == null"
          >
            <v-list-tile-title>Lim inn geometri</v-list-tile-title>
          </v-list-tile>
          <v-list-tile
            @click="editDrawingLayer"
            v-if="item.type == 'graphicsLayer'"
          >
            <v-list-tile-title>Rediger tegnelag</v-list-tile-title>
          </v-list-tile>
          <v-list-tile
            @click="activateChangeLayerNameDialog"
            v-if="item.type == 'graphicsLayer'"
          >
            <v-list-tile-title>Endre navn/besk.</v-list-tile-title>
          </v-list-tile>
          <v-divider></v-divider>
          <v-list-tile @click="removeTheme">
            <v-list-tile-title>Fjern kartlaget</v-list-tile-title>
          </v-list-tile>
          <v-divider></v-divider>

          <v-divider></v-divider>
          <v-list-tile
            @click="hideMenu()"
            :href="item.serviceUrl"
          >
            <v-list-tile-title>Åpne karttjeneste</v-list-tile-title>
          </v-list-tile>
        </v-list>
        <v-divider></v-divider>

        <v-card-actions v-show="false" color="grey">
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="menu = false">Lukk</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>

    <map-drawing-change-layer-name-dialog
      :active="changeLayerNameDialogActive"
      :current-name="item.appTitle"
      :current-description="item.Temaforklaring"
      @close-dialog="deactivateChangeLayerNameDialog"
      :layer="item"
    />
  </div>
</template>

<script>
import LayerFavouriteToggler from "@/components/LayerFavouriteToggler";
import MapDrawingChangeLayerNameDialog from "@/pages/MapPage/Tools/Drawing/MapDrawingChangeLayerNameDialog";
import { mapState, mapActions } from "vuex";
import MappingMixin from "@/mixins/mappingMixin";
import ExtractMixin from "@/mixins/extractMixin";
export default {
  name: "LayerListItemMenu",
  components: { LayerFavouriteToggler, MapDrawingChangeLayerNameDialog },
  mixins: [MappingMixin, ExtractMixin],
  computed: {
    ...mapState(["selectedTheme", "copiedGeometry"]),
    ...mapState(["theMap"]),
    mapProfiles: {
      get() {
        return this.$store.state.mapProfiles;
      },
      set(value) {
        this.updateMapProfiles(value);
      }
    },
    index() {
      return this.$store.state.mapProfiles.findIndex(profile => {
        return profile.id == this.item.id;
      });
    },
    profileHasDescription() {
      return this.item.Temaforklaring;
    }
  },
  watch: {
    menu: function(newVal) {
      if (newVal == true) {
        this.$emit("menu-open");
      } else {
        this.$emit("menu-close");
      }
    }
  },
  methods: {
    ...mapActions([
      "setSelectedMapProfile",
      "activateTool",
      "updateMapProfiles",
      "setSelectedTheme",
      "setShowInfoMenu"
    ]),
    downloadAsShape(item) {
      let graphicsLayer = this.$theMapObject.findLayerById(item.id);

      this.downloadGraphicsAsShapeFile(graphicsLayer.graphics.items);
    },
    openInfo(evt, item) {
      if (this.selectedTheme && this.selectedTheme === item.id) {
        this.setSelectedTheme(null);
        this.setShowInfoMenu(false);
      } else {
        this.setSelectedTheme(item.id);
        this.setShowInfoMenu(true);
      }
    },
    pasteGeometry() {
      this.pasteGeometryIntoGraphicsLayer({
        geometry: this.copiedGeometry,
        layerID: this.item.id
      });
    },
    toggleTheme() {
      this.setMapLayerVisibility({
        profile: this.item,
        visible: !this.item.visible
      });
    },
    placeOnTop() {
      let mapProfilesCopy = JSON.parse(JSON.stringify(this.mapProfiles));
      let index = this.mapProfiles.findIndex(
        profile => profile.id === this.item.id
      );
      let profileBeingMoved = mapProfilesCopy.splice(index, 1)[0];
      mapProfilesCopy.push(profileBeingMoved);
      this.mapProfiles = mapProfilesCopy;
      this.reorder(this.item.id, this.mapProfiles.length + 1);
      this.hideMenu();
    },
    placeOnBottom() {
      let mapProfilesCopy = JSON.parse(JSON.stringify(this.mapProfiles));
      let index = this.mapProfiles.findIndex(
        profile => profile.id === this.item.id
      );
      let profileBeingMoved = mapProfilesCopy.splice(index, 1)[0];

      mapProfilesCopy.unshift(profileBeingMoved);

      this.mapProfiles = mapProfilesCopy;
      this.reorder(this.item.id, 0);
      this.hideMenu();
    },
    removeTheme() {
      this.removeMapProfile(this.item.id);
      this.hideMenu();
    },
    reorder(id, newIndex) {
      let exisitingLayer = this.$theMapObject.findLayerById(id);
      newIndex = newIndex + 2;
      this.$theMapObject.reorder(exisitingLayer, newIndex);
    },
    editDrawingLayer() {
      this.setSelectedMapProfile(this.item);
      this.activateTool("drawing");
      this.hideMenu();
    },
    hideMenu() {
      this.menu = false;
    },
    setOpacity(layerId, opacity) {
      this.setMapLayerOpacity({ id: layerId, opacity: opacity / 100 });
    },
    deactivateChangeLayerNameDialog() {
      this.changeLayerNameDialogActive = false;
    },
    activateChangeLayerNameDialog() {
      this.changeLayerNameDialogActive = true;
    }
  },
  mounted() {
    let layer = this.theMap.findLayerById(this.item.id);
    if (typeof layer !== "undefined") {
      this.opacity = layer.opacity;
    }
  },
  props: {
    item: Object,
    color: String
  },
  data() {
    return {
      changeLayerNameDialogActive: false,
      menu: false,
      opacity: 100
    };
  }
};
</script>

<style></style>
